function register(state = { emailFree: false, nicknameFree: false }, action) {
  switch (action.type) {
    case 'EMAIL_CHECK':
      return {
        ...state,
        emailFree: !action.result,
      };
    case 'NICKNAME_CHECK':
      return {
        ...state,
        nicknameFree: !action.result,
      };
    default:
      return state;
  }
}

export default register;
